import { render } from "./CreateNewAccount.vue?vue&type=template&id=904e0226&scoped=true"
import script from "./CreateNewAccount.vue?vue&type=script&lang=js"
export * from "./CreateNewAccount.vue?vue&type=script&lang=js"

import "./CreateNewAccount.vue?vue&type=style&index=0&id=904e0226&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-904e0226"]])

export default __exports__